import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import { useUtilities } from "@/hooks/useUtilities"


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableTextBlock',
  props: {
  limit: {
    type: Number,
    default: 200,
  },
  color: {
    type: String,
    default: "#2f80ed",
  },
  expandedLabel: {
    type: String,
    default: "Less",
  },
  collapsedLabel: {
    type: String,
    default: "More",
  },
},
  setup(__props) {


const expanded = ref(false)

const { truncate } = useUtilities()

return { __sfc: true,expanded, truncate }
}

})